import { createFileRoute } from "@tanstack/react-router";
import GetHelpInYourArea from "@/components/GetHelpInYourArea";

export const Route = createFileRoute("/(content)/get-help")({
  component: GetHelpComponent,
  beforeLoad: () => ({
    title: "getHelp.title",
    navbar: {
      showTitle: true,
    },
  }),
});

function GetHelpComponent() {
  return (
    <div className="">
      <GetHelpInYourArea />
    </div>
  );
}
